export const getImageNaturalOrientation = (naturalWidth, naturalHeight) => {
  if (naturalWidth > naturalHeight) {
    return 'horizontal';
  }

  if (naturalWidth < naturalHeight) {
    return 'vertical';
  }

  return 'same';
};
